/*
 * Gaat terug naar de vorige pagina zoals de browser-back-knop, maar enkel
 * als die vorige pagina op deze site was (anders blijft "terug" een stap
 * terug zetten in een andere site, bv. Google). Komt de bezoeker van
 * buiten de site (of is er geen geschiedenis, bv. rechtstreeks via een
 * gedeelde link), dan gaat de knop naar het volledige productoverzicht.
 */
document.addEventListener('click', function (event) {
  var button = event.target.closest('.product__back-button');
  if (!button) return;

  var cameFromSameSite = false;
  if (document.referrer) {
    try {
      cameFromSameSite = new URL(document.referrer).origin === window.location.origin;
    } catch (error) {
      cameFromSameSite = false;
    }
  }

  if (cameFromSameSite && window.history.length > 1) {
    window.history.back();
  } else {
    window.location.href = button.getAttribute('data-fallback-url');
  }
});
